import { Typography } from "@mui/material";
import React from 'react';


const CustomTypography = ({ variant, title, color, fontWeight, children, ...props }) => {
    return (
        <Typography
            gutterBottom
            variant={variant}
            color={color}
            sx={{
                // Consistent Font Weight (Adjust based on the title importance)
                fontWeight: fontWeight || 500,

                // Adjust Line Height for Better Readability
                lineHeight: { xs: '1.3', md: '1.5' },

                // Consistent Padding to Align with Form Elements
                padding: { xs: '4px 8px', md: '6px 12px' },

                // Optional Color for Visual Hierarchy
                color: color || 'text.primary',
            }}
        >
            {children}
        </Typography>


    );
};

export default CustomTypography;
